exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card {\n  margin: 218px;\n  float: none;\n  padding: 70px;\n  text-align: center;\n  margin-bottom: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/report/report component/no-report/no-report.component.scss
// module id = ../../../../../src/app/report/report component/no-report/no-report.component.scss
// module chunks = main